import { APP_URL, CURRENCY_URL } from "../constants";
import { httpClient } from "../utils/http-client";

const addCurrency = async (currencyInfo, token) => {
  try {
    return await httpClient.postFile(
      `${APP_URL}/v1/fx/currencies`,
      currencyInfo,
      {
        Authorization: `Bearer ${token}`,
        locale: navigator.language,
      }
    );
  } catch (error) {
    console.log("Error creating a new Currency", error);
    return error;
  }
};

const getCurrencies = () => {
  try {
    return httpClient.get(`${APP_URL}/v1/fx/currencies/all`, {
      locale: navigator.language,
    });
  } catch (error) {
    console.log("Error getting currencies", error);
    return error;
  }
};

const fetchAvailableCurrencies = (token) => {
  try {
    return httpClient.get(`${APP_URL}/v1/fx/currencies`, {
      Authorization: `Bearer ${token}`,
      locale: navigator.language,
    });
  } catch (error) {
    console.log("Error getting Currencies", error);
  }
};

const updateCurrencyAvailable = async (id, data, token) => {
  try {
    return httpClient.put(APP_URL + `/v1/fx/currencies/${id}`, data, {
      Authorization: `Bearer ${token}`,
      locale: navigator.language,
    });
  } catch (error) {
    console.log("Error updating currencies", error);
    return error;
  }
};

const deleteCurrencyAvailable = async (id, token) => {
  try {
    return httpClient.delete(APP_URL + `/v1/fx/currencies/${id}`, {
      Authorization: `Bearer ${token}`,
      locale: navigator.language,
    });
  } catch (error) {
    console.log("Error updating currencies", error);
    return error;
  }
};

export {
  getCurrencies,
  fetchAvailableCurrencies,
  updateCurrencyAvailable,
  addCurrency,
  deleteCurrencyAvailable,
};
